import { css } from '@compiled/react';
import { media } from '@atlaskit/primitives/responsive';
import { useLocation } from 'react-router-dom';

import { getAssetUrl } from 'src/services/http/user';

export const Banner = () => {
  const { pathname } = useLocation();

  const isTeamTraining = pathname.includes('team-training');

  const bannerImage = isTeamTraining
    ? getAssetUrl('/images/contentBanners/courseDescriptionBanner.svg')
    : getAssetUrl('/images/contentBanners/publicClassBanner.svg');

  const heights = isTeamTraining
    ? { base: '2rem', sm: '2.5rem', xl: '3rem' }
    : { base: '5rem', sm: '5rem', xl: '5rem' };

  return (
    <div
      css={bannerStyles}
      style={
        {
          '--banner-image': `url(${bannerImage})`,
          '--banner-height-base': heights.base,
          '--banner-height-sm': heights.sm,
          '--banner-height-xl': heights.xl,
        } as Record<string, string>
      }
      role="img"
      aria-label="Team Training Banner"
    />
  );
};

const bannerStyles = css({
  height: 'var(--banner-height-base)',
  width: '100%',
  objectFit: 'cover',
  backgroundImage: 'var(--banner-image)',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  marginTop: '0',

  [media.above.sm]: {
    height: 'var(--banner-height-sm)',
  },

  // Custom breakpoint needed since standard media doesn't have 1280px and learning components use this breakpoint
  '@media (min-width: 1280px)': {
    height: 'var(--banner-height-xl)',
    marginTop: '136px',
  },
});
